import {useAuthContext} from "@/hooks/useAuthContext"
import FileUploadIcon from "@mui/icons-material/FileUpload"
import {FileInfo, FileCard} from "./FileCard"
import React, {useState, useEffect} from "react"
import {useLocation} from "react-router-dom"
import {getFiles} from "@/api/archivos"
import {FilePopUp} from "@/components/files/FilePopUpWindow"

function FilesEntitySection({id}: {id: string}) {
   const MAX_PUBLIC_FILES = 4
   const MAX_PRIVATE_FILES = 12

   const location = useLocation()
   const {pathname} = location

   const editFilesView = pathname.includes("editFiles") ? true : false
   const editFilesRoute = pathname.includes("inmuebles") ? "inmuebles" : "condominios"

   const {user} = useAuthContext()

   const [selectedPublicFiles, setSelectedPublicFiles] = useState<FileInfo[]>([])
   const [selectedPrivateFiles, setSelectedPrivateFiles] = useState<FileInfo[]>([])

   const [isPopupVisible, setPopupVisibility] = useState(false)
   const [privacyBox, setPrivacyBox] = useState<boolean>(false)
   const [operation, setOperation] = useState<boolean>(false)
   const [data, setData] = useState<FileInfo[]>([])
   const [indexDeleteFile, setIndexDeleteFile] = useState<number>(0)

   //* Funciones del componente */

   const togglePopup = (upload: boolean, mode: boolean, index?: number) => {
      if (!mode) {
         setData(selectedPublicFiles)
      } else {
         setData(selectedPrivateFiles)
      }

      if (upload) {
         //*Revisamos si podemos subir mas archivos
         if (!mode && selectedPublicFiles.length >= MAX_PUBLIC_FILES) {
            console.error(`No se pueden subir más archivos públicos`)
            alert(`No se pueden subir más archivos públicos`)
            return
         }

         if (mode && selectedPrivateFiles.length >= MAX_PRIVATE_FILES) {
            console.error(`No se pueden subir más archivos privados`)
            alert(`No se pueden subir más archivos privados`)
            return
         }
         setOperation(true)
      }
      if (!upload) {
         setOperation(false)
         if (index !== undefined) {
            setIndexDeleteFile(index)
         }
      }
      setPrivacyBox(mode)
      setPopupVisibility(true)
   }

   //*Funcion para convertir de forma visual los datos

   const fileCardManager = (data: any, mode: boolean) => {
      const newFiles: FileInfo[] = []

      data.forEach((file: any) => {
         const userFile: FileInfo = {
            name: file.name,
            size: file.size,
            type: file.type,
            url: file.url,
         }
         newFiles.push(userFile)
      })

      if (!mode) {
         // Avoid adding duplicates by file name
         const filteredFiles = newFiles.filter(
            (file) => !selectedPublicFiles.some((existingFile) => existingFile.name === file.name),
         )
         setSelectedPublicFiles((prev) => [...prev, ...filteredFiles])
      } else if (mode) {
         // Avoid adding duplicates by file name
         const filteredFiles = newFiles.filter(
            (file) => !selectedPrivateFiles.some((existingFile) => existingFile.name === file.name),
         )
         setSelectedPrivateFiles((prev) => [...prev, ...filteredFiles])
      }
   }

   const deleteFileCard = (index: number, mode: boolean) => {
      if (!mode) {
         const newFiles = selectedPublicFiles.filter((_, i) => i !== index)
         setSelectedPublicFiles(newFiles)
      } else {
         const newFiles = selectedPrivateFiles.filter((_, i) => i !== index)
         setSelectedPrivateFiles(newFiles)
      }
   }

   //* React and TS events */

   useEffect(() => {
      //* Obtenemos archivos publicos y privados de la entidad cada modificacion del componente

      const fecthInitialFiles = async () => {
         const files = await getFiles(id)
         const resPublic = files?.data.publicFiles || []
         const resPrivate = files?.data.privateFiles || []
         if (resPublic.length > 0) {
            fileCardManager(resPublic, false)
         }
         if (resPrivate.length > 0) {
            fileCardManager(resPrivate, true)
         }
      }

      fecthInitialFiles()
   }, [])

   return (
      <div className="w-[90%] mb-[5%] mx-[5%] flex flex-col gap-y-4 ">
         {/* Public Files */}
         <section className="flex flex-col ">
            <div className="rounded-sm border outline-solid p-2 flex-1">
               <h4 className="text-blue text-center mb-2">Archivos publicos</h4>
               {selectedPublicFiles.length > 0 ? (
                  <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-4 items-center justify-center justify-items-center">
                     {selectedPublicFiles.map((file, index) => (
                        <FileCard
                           key={file.name + index}
                           file={file}
                           editFiles={editFilesView}
                           onEliminar={() => togglePopup(false, false,index)}
                        />
                     ))}
                  </div>
               ) : (
                  <p className="text-center text-gray-500">
                     No hay archivos publicos para esta entidad
                  </p>
               )}
            </div>
            {editFilesView ? (
               <div className="flex flex-col justify-center mb-8">
                  <p className="text-gray-400 self-center">
                     <em>Cantidad de archivos maximo : 4</em>
                  </p>
                  <p className="text-gray-400 self-center">
                     <em>Tamaño maximo para cada archivo es de : 10 MB</em>
                  </p>
                  <button
                     onClick={() => {
                        togglePopup(true, false)
                     }}
                     className="cursor-pointer rounded bg-blue text-white text-center w-[50%] self-center mt-4"
                  >
                     Subir nuevo archivo publico <FileUploadIcon />
                  </button>
               </div>
            ) : null}
         </section>
         {/* Private Files */}
         {user.admin && (
            <section className="flex flex-col">
               <div className="rounded-lg border-2 border-green outline-solid p-2 flex-1">
                  <h4 className="text-green text-center mb-2">Archivos privados</h4>
                  {selectedPrivateFiles.length > 0 ? (
                     <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-4 items-center justify-center justify-items-center">
                        {selectedPrivateFiles.map((file, index) => (
                           <FileCard
                              key={file.name + index}
                              file={file}
                              editFiles={editFilesView}
                              onEliminar={() => togglePopup(false, true,index)}
                           />
                        ))}
                     </div>
                  ) : (
                     <p className="text-center text-gray-500">
                        No hay archivos privados para esta entidad
                     </p>
                  )}
               </div>
               {editFilesView ? (
                  <div className="flex flex-col justify-center">
                     <p className="text-gray-400 self-center">
                        <em>Cantidad de archivos maximo : 12 </em>
                     </p>
                     <p className="text-gray-400 self-center">
                        <em>Tamaño maximo para cada archivo es de : 10 MB</em>
                     </p>
                     <button
                        onClick={() => togglePopup(true, true)}
                        className="cursor-pointer rounded bg-blue text-white text-center w-[50%] self-center mt-4"
                     >
                        Subir nuevo archivo privado <FileUploadIcon />
                     </button>
                  </div>
               ) : null}
            </section>
         )}
         {/* Popup of file (Resolve logic) */}
         {isPopupVisible &&
            (operation ? (
               <FilePopUp
                  apiOperation={operation}
                  apiId={id}
                  apiMode={privacyBox}
                  apiRoute={editFilesRoute}
                  apiData={data}
                  onFileCard={fileCardManager}
                  onClose={() => setPopupVisibility(false)}
               />
            ) : (
               <FilePopUp
                  apiOperation={operation}
                  apiId={id}
                  apiMode={privacyBox}
                  apiRoute={editFilesRoute}
                  apiData={data}
                  apiIndex={indexDeleteFile}
                  onDeleteCard={deleteFileCard}
                  onClose={() => setPopupVisibility(false)}
               />
            ))}
      </div>
   )
}

export default FilesEntitySection
